/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { Home, Profile, ChangePassword, } from 'features/components/base';
import { LocationsRouter } from './LocationsRouter';
import SalesRouter  from './SalesRouter';
import ReportRouter  from './ReportRouter';
import { BuyerRouter } from './BuyerRouter';
import { InvoiceRouter } from './InvoiceRouter';
import { MessageRouter } from './MessageRouter';
import { HelpRouter } from './HelpRouter';
import { connect } from 'react-redux'; 
import { Fullfillment } from 'features/components/base/fullfillment/Fullfillment';

/**
 * routing for base components
 * 
 * @param props
 * 
 * @return routing for base components
 * 
**/

class AppRouter extends Component {
    render() {
        return (
            <Switch>
                <Route exact path={`/home`} component={Home} />

                <Route path={`/locations`} component={LocationsRouter} >
                    {
                        this.props.user.role.includes('Administrator') ? <LocationsRouter {...this.props} /> : <Redirect to="/home" />
                    }
                </Route>

                <Route path={`/sales`} component={SalesRouter} />

                <Route path={`/buyer`} >
                    {
                       this.props.user.role.includes('Administrator') || this.props.user.role.includes('Staff') ? <BuyerRouter {...this.props} /> : <Redirect to="/home" />
                    }
                </Route>    

                <Route path={`/invoice`} component={InvoiceRouter} />
                <Route path={`/reports`} component={ReportRouter} />
                <Route path={`/messages`} component={MessageRouter} />
                {/* <Route exact path={`/support`} component={SupportView} /> */}

                <Route exact path={`/profile`} component={Profile} />
                <Route exact path={`/change-password`} component={ChangePassword} />
                <Route exact path={`/fulfillment/:invoiceId`} component={Fullfillment} />
                <Route path={`/help-center`} component={HelpRouter} />

                <Redirect to="/home" />
            </Switch>
        );
    }
}
export default connect(state => state)(AppRouter);